<template>
  <router-view></router-view>
</template>

<script>
export default {
  name:  'exhibition-control-controlCase',
  data() {
    return {

    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 案例";
  }
}
</script>

<style scoped lang="scss">

</style>
